import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

import pt from '../locales/pt';

const pagePad =
  'px-space-5 py-space-12 mid:px-space-10 mid:py-space-16 wide:px-space-20 wide:py-space-24';

/**
 * Privacy · 375/768/1280 × light/dark — evplanner-gleb-design-system.pen
 */
export function Privacy() {
  const sections = pt.legal.privacy.sections;

  return (
    <section className={`flex flex-col items-center ${pagePad}`}>
      <div className="flex w-full max-w-3xl flex-col gap-space-10">
        <div className="flex flex-col gap-space-3">
          <span className="type-section text-sage-700 dark:text-sage-300">{pt.legal.eyebrow}</span>
          <h1 className="type-landing-h2">{pt.legal.privacy.title}</h1>
        </div>

        <p className="type-body text-muted-foreground">{pt.legal.privacy.intro}</p>

        <div className="flex flex-col gap-space-4">
          <h2 className="type-title-page">{sections.cookies.title}</h2>
          <p className="type-body text-muted-foreground">{sections.cookies.body}</p>
          <ul className="flex flex-col gap-space-2 type-body-sm text-muted-foreground">
            {sections.cookies.items.map((item) => (
              <li key={item} className="flex gap-space-3">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-ds-full bg-sage-600" aria-hidden />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-space-4">
          <h2 className="type-title-page">{sections.rights.title}</h2>
          <p className="type-body text-muted-foreground">{sections.rights.body}</p>
        </div>

        <Link
          to="/terms"
          className="inline-flex items-center gap-space-2 type-body font-semibold text-sage-700 hover:underline dark:text-sage-300"
        >
          {pt.legal.privacy.termsLink}
          <ArrowRight className="h-4 w-4" aria-hidden />
        </Link>
      </div>
    </section>
  );
}
